import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { AssessmentCollectionLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";

const Assessment_collection_Notice = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {AssessmentCollectionLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass">{t("Notice")} </h3>
                  </div>
                  <div className="about-head1">
                    <div className="dig-login1 dig-login2">
                      <form>
                        <div className="log-form inner-log-form">
                          <h3 className="fontSizeClass">
                            {t("List of Notices")}
                          </h3>
                          <div className="row">
                            <div className="col-lg-12 col-md-12 form-group pt-2">
                              <div className="list-of-forms">
                                <ul>
                                  <li>
                                    <h6 className="fontSizeClass">
                                      <DownloadFileByFileStoreId
                                        fileStoreId={
                                          "18017126-2a59-4f3c-8a94-891f18042026"
                                        }
                                        label={
                                          "Shifting of Baghajatin Treasury Counter to e-Kolkata Citizen Service Centre"
                                        }
                                      />
                                    </h6>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Assessment_collection_Notice;
